export const DEFAULTS = {
  PLATFORM_URL: `https://zbo.zpush.io/zbo/pub/business`,
  DEFAULT_NAMESPACE: ``,
  FRONT_FOLDER_PATH: `front`,
  WORKER_FOLDER_PATH: `.`,
  NPM_REGISTRY_URL: 'https://registry.npmjs.org',
  TS_NODE_SKIP_IGNORE: 'false'
};
